module.exports = __webpack_public_path__ + "img/card-back-red.7857a37d.svg";